import {
  commonChecks as commonChecksFunc,
  DEFAULT_RESULT,
} from './src/commonChecks.js'
import { commonChecksInNode } from './src/commonChecksInNode.js'

export { getOS, getOSVersion } from './src/os.js'
export { getBrowser, getBrowserVersion } from './src/browser.js'
export { getNetType } from './src/netType.js'
export { isMiniprogram, MINI_PROGRAM_FLAG, MP_TYPES } from './src/miniProgram.js'
export { getSource } from './src/source.js'
export { commonChecksInNode as getCommonChecksInNode }

function validateOptions(opts) {
  let result = true;

  ['userAgent', 'url'].forEach(key => {
    if (!opts[key]) {
      result = false
    }
  })

  return result
}

export function getCommonChecks(opts) {
  if (process.env.BROWSER) {
    return commonChecksFunc(window)
  }

  if (!validateOptions(opts)) {
    throw new Error('param error')
  }

  return commonChecksInNode(opts)
}

export const commonChecks = (() => {
  if (process.env.BROWSER) {
    return commonChecksFunc(window)
  }

  return DEFAULT_RESULT
})()
